module.exports = __webpack_public_path__ + "img/partner-new1.af31b0e8.png";